module.exports = __webpack_public_path__ + "img/article-defaultImg-big.b00fd761.png";